window.VH = window.VH === undefined ? {} : window.VH;
VH.ChartHelper = {
    setChart : function setChart() {
        let _t = VH.ChartHelper,
            t = $(this);
        // const myChart = new Chart(t[0], {
        //     type: 'line',
        //     data: t.data('data'),
        //     options: {
        //         maintainAspectRatio: false,
        //         scales: {
        //             y: {
        //                 beginAtZero: true
        //             }
        //         },
        //         plugins: {
        //             legend: {
        //                 labels: {
        //                     font: {
        //                         size: 20
        //                     }
        //                 }
        //             }
        //         }
        //     }
        // });

        const myChart = new frappe.Chart(t[0], t.data('data'));
    },
    init : function init() {
        let _t = VH.ChartHelper;
        //Chart.defaults.color = 'white';
        $('.utxChart').each(_t.setChart);
    }
};